<div class="bg-white p-4 settings-list settings-container">
    @for (setting of emailSettings(); track setting.id) {
        <div class="settings-row lendio-density-2 p-4">
            <mat-slide-toggle 
                class="lendio-small-slide-toggle" 
                [ngModel]="setting.status"
                (change)="handleSettingChange(setting)"></mat-slide-toggle>
            <div class="settings-content">
                <div><b>{{ setting.label }}</b></div>
                <div>{{ setting.helpText }}</div>
            </div>
            @if (setting.children?.length > 0 && setting.status) {
            <div class="settings-menu">
                <button mat-flat-button
                    [@fadeIn]
                    [@fadeOut]
                    class="settings-button"
                    color="accent"
                    [matMenuTriggerFor]="settingsMenu">
                    {{ setting.children | getActiveSettingLabel }}
                    <mat-icon iconPositionEnd>expand_more</mat-icon>
                </button>
                <mat-menu #settingsMenu="matMenu">
                    @for (child of setting.children; track child.id) {
                        <button mat-menu-item
                        (click)="handleSettingChildChange(setting)"
                        [disabled]="child.status">
                        {{ child.label }}
                        </button>
                    }
                </mat-menu>
            </div>
            }
        </div>
    }
</div>